<script lang="ts">
  import AuditLogTable from "@kontextwerk/control-web-frame/components/audit/AuditLogTable.svelte"
  import { getAdminApi } from "../../../../../../api/kehrblatt/client"
  import type { OrgaViewFrameContext } from "../../../../context"
  import { frameConfig } from "@kontextwerk/control-web-frame"
  import { composeControlActivityCatalog } from "@kontextwerk/control-web-frame"

  const { viewFrameContext } = $props<{
    viewFrameContext: OrgaViewFrameContext
  }>()
  const organization = $derived(viewFrameContext.organization)
  const activityCatalog = $derived(composeControlActivityCatalog($frameConfig?.activity?.catalog))
</script>

{#if organization}
  <AuditLogTable
    title="Protokoll"
    catalog={activityCatalog}
    fetchActivityTypes={async () => (await getAdminApi().activity.listCatalog()).items}
    fetchActivityDetail={(id) => getAdminApi().activity.getEvent(organization.id, id)}
    fetchAuditEvents={(params) => getAdminApi().audit.listForOrg(organization.id, params)}
    fixedOrganizationId={organization.id}
    showOrganizationColumn={false}
  />
{/if}
